module.exports = __webpack_public_path__ + "static/SharpSansNo1-Medium-e771c76ce5e596e87565b1efd50762d9.woff";